import type { CSSProperties } from 'react';
import { backgroundColors } from '../assets/colors';
import { computeColor } from './colors';

/**
 *
 * Get background style from background colors.
 *
 * Returned empty object if the parameter is `undefined`. Otherwise,
 * will return an object with a `background` property.
 *
 * @param background
 */
export const getBackgroundColorStyle = (background?: string): Pick<CSSProperties, 'background'> => {
  if (!background) return {};

  return {
    background: computeColor(background, backgroundColors),
  };
};

export const getBackgroundImageStyle = (
  backgroundImage?: string,
  backgroundDarken?: boolean
): Pick<
  CSSProperties,
  | 'backgroundRepeat'
  | 'backgroundSize'
  | 'backgroundColor'
  | 'backgroundBlendMode'
  | 'backgroundPosition'
> => {
  if (!backgroundImage) return {};

  return {
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center', // to make this the same as if using optimized image for background
    ...(backgroundDarken
      ? {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          backgroundBlendMode: 'darken',
        }
      : {}),
  };
};
